import React, { useState } from "react";
import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import welcomeIcon from "../../assets/auth/welcome.png";
import { supabase } from "../../auth/supabase";

const AuthGatePopup = ({ onClose }) => {
  const navigate = useNavigate();
  const [guestLoading, setGuestLoading] = useState(false);
  const [guestError, setGuestError] = useState("");
  const handleLogin = () => {
    onClose();
    navigate("/login");
  };
  const continueAsGuest = async () => {
    setGuestLoading(true);
    setGuestError("");
    const { error } = await supabase.auth.signInAnonymously();
    setGuestLoading(false);
    if (error) return setGuestError("Guest access is unavailable right now. Please try again.");
    onClose();
  };
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999] p-4 animate-fadeIn font-poppins">
      <div className="bg-white dark:bg-gray-900 rounded-[20px] shadow-[0_25px_60px_rgba(0,0,0,0.2)] w-full max-w-[518px] min-h-[360px] max-h-[90vh] overflow-hidden relative animate-slideUp">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 sm:top-5 sm:right-5 text-gray-400 hover:text-gray-900 dark:hover:text-white hover:rotate-90 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-300 p-1 rounded-lg z-10"
        >
          <X className="w-[22px] h-[22px]" />
        </button>
        <div className="px-5 sm:px-9 pt-6 sm:pt-7 pb-6 sm:pb-8 text-center">
          <div className="flex items-center justify-center mx-auto mb-4">
            <img
              src={welcomeIcon}
              alt="Welcome"
              className="w-14 h-14 sm:w-16 sm:h-16 object-contain"
            />
          </div>
          <h3 className="text-[20px] sm:text-[24px] font-semibold font-notosans text-[#151D2D] dark:text-white mb-2 tracking-tight leading-tight">
            Welcome to Akkorent!
          </h3>
          <p className="text-[13px] sm:text-[14px] text-[#757575] text-regular font-noto dark:text-gray-400 leading-relaxed mb-5 mx-auto">
            We're excited to have you here. Explore our features and
            discover everything we have to offer. Thank you for visiting!
          </p>
          <div className="flex flex-col sm:flex-row gap-3.5 mb-4">
            <button
              onClick={handleLogin}
              className="flex-1 py-3 px-6 rounded-[24px] text-[16px] font-medium bg-[#2563EB] text-white border-2 border-[#2563EB] hover:bg-[#1044cc] hover:border-[#1044cc] hover:shadow-[0_4px_16px_rgba(59,130,246,0.35)] hover:-translate-y-0.5 active:scale-[0.97] transition-all duration-200 cursor-pointer tracking-[0.01em]"
            >
              Sign in
            </button>
            <button
              onClick={continueAsGuest}
              disabled={guestLoading}
              className="flex-1 py-3 px-6 rounded-[24px] text-[16px] font-medium bg-transparent text-[#2563EB] border-2 border-[#2563EB] hover:bg-blue-500/5 hover:shadow-[0_4px_16px_rgba(59,130,246,0.15)] hover:-translate-y-0.5 active:scale-[0.97] transition-all duration-200 cursor-pointer tracking-[0.01em] dark:text-blue-400 dark:border-blue-400"
            >
              {guestLoading ? "Starting…" : "Continue as Guest"}
            </button>
          </div>
          {guestError && <p role="alert" className="mb-4 text-sm text-red-600">{guestError}</p>}
          <label className="flex items-center gap-2.5 cursor-pointer select-none">
            <input
              type="checkbox"
              onChange={(e) => {
                if (e.target.checked) {
                  localStorage.setItem("auth_gate_dismissed", "true");
                } else {
                  localStorage.removeItem("auth_gate_dismissed");
                }
              }}
              className="w-[18px] h-[18px] rounded border-2 border-gray-300 dark:border-gray-600 appearance-none cursor-pointer checked:bg-blue-500 checked:border-blue-500 transition-all duration-200 relative
              after:content-[''] after:absolute after:left-[5px] after:top-[1px] after:w-[5px] after:h-[10px] after:border-white after:border-r-2 after:border-b-2 after:rotate-45 after:hidden checked:after:block shrink-0"
            />
            <span className="text-[14px] text-[#757575] font-medium">
              Don't show this again
            </span>
          </label>
        </div>
      </div>
    </div >
  );
};

export default AuthGatePopup;
